export default "__VITE_ASSET__bSZrtPXq__"